export enum EApiUpstream {
	MPOP = 'mpop',
	MYDAWN = 'mydawn'
}
